import axiosClient from "../axios/axiosClient";

export function getPartnerTypes() {
  return axiosClient.get("/partner-types");
}

export function getPartnerType(partnerTypeId) {
  return axiosClient.get(`/partner-types/${partnerTypeId}`);
}

export function createPartnerType(data) {
  return axiosClient.post("/partner-types", data);
}

export const updatePartnerType = (partnerTypeId, data) => {
  return axiosClient.put(`/partner-types/${partnerTypeId}`, data);
};

export function deletePartnerType(partnerTypeId) {
  return axiosClient.delete(`/partner-types/${partnerTypeId}`);
}
